import { Injectable } from '@rxdi/core';

@Injectable()
export class FooterService {}
